export enum FEEDBACK_TYPES {
  WITH_COMMENT = 'WITH_COMMENT',
  WITHOUT_COMMENT = 'WITHOUT_COMMENT',
}
